import { WithStyles } from "@material-ui/core";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./MyReportsView.styles";
import * as SingleIsinReportAction from "../../../../stores/reports/singleIsin/SingleIsinReportAction";
import { useSelector } from "react-redux";
import { IUniversalTableColumn, IUniversalTableData } from "../../../components/UniversalTable/interfaces";
import { selectRequesting } from "../../../../selectors/requesting/RequestingSelector";
import UniversalTable from "../../../components/UniversalTable/UniversalTable";

interface ISingleIsinReportForSummary {
    id: number;
    created: string;
    price: number;
    discount: number;
    totalPrice: number;
    reportLink: string;
}

interface ISingleIsinReportMonthlySummary {
    month: number;
    totalAmount: number;
    reports: ISingleIsinReportForSummary[];
}

export interface IMyReportsSummaryViewProps extends WithStyles<typeof styles> {}

const MyReportsSummaryViewPure: React.FunctionComponent<IMyReportsSummaryViewProps> = ({
    classes
}: IMyReportsSummaryViewProps) => {

    const reportSummaryFromState = useSelector(state => state.singleIsinsReports?.userMonthlySummary);
    const isRequesting = useSelector(state =>
        selectRequesting(state, [SingleIsinReportAction.REQUEST_USER_REPORTS_MONTHLY_SUMMARY])
    );
    let monthlySummaries: IUniversalTableData;

    if (reportSummaryFromState) {
        monthlySummaries = Object.values(reportSummaryFromState)
            .map((summary: ISingleIsinReportMonthlySummary) => ({
                month: summary.month,
                totalAmount: summary.totalAmount,
                reports:summary.reports
            }));
    }

    const columns: IUniversalTableColumn[] = [
        {
            type: "date",
            title: "Month",
            field: "month",
            format: "MMMM YYYY"
        },
        {
            type: "price",
            title: "Total amount (excl. VAT)",
            field: "totalAmount"
        }
    ];

    const detailPanelTableColumns: IUniversalTableColumn[] = [
        {
            title: "Report ID",
            field: "id",
            type: "text"
        },
        {
            type: "price",
            title: "Subtotal",
            field: "price"
        },
        {
            type: "price",
            title: "Discount Amount",
            field: "discount"
        },
        {
            title: "Total amount (excl. VAT)",
            field: "totalPrice",
            type: "price"
        },
        {
            title: "Created on",
            field: "created",
            type: "dateTime"
        },
        {
            title: "Report",
            linkField: "reportLink",
            type: "link",
            linkTitle: "Download",
            titleIfLinkNotAvailable: "Link not available"
        }
    ];

    const detailPanel = rowData => {
        return <UniversalTable columns={detailPanelTableColumns} data={rowData?.reports} isLoading={isRequesting} searchable />;
    }

    return <UniversalTable columns={columns} data={monthlySummaries} isLoading={isRequesting} searchable detailPanel={detailPanel} />;
};

export const MyReportsSummaryView = withStyles(styles)(MyReportsSummaryViewPure);
